import { GiftType } from '../../types/invitation';

export interface GiftFormData {
  guestName: string;
  guestEmail: string;
  amount: number;
  currency: string;
  giftType: GiftType;
  giftDescription: string;
  message: string;
  rsvpId?: string;
}

export const INITIAL_FORM_DATA: GiftFormData = {
  guestName: '',
  guestEmail: '',
  amount: 0,
  currency: 'TWD',
  giftType: 'cash',
  giftDescription: '',
  message: '',
  rsvpId: undefined,
};

export type GiftTabId = 'overview' | 'records' | 'bulk' | 'add';

export const GIFT_TABS = [
  { id: 'overview' as const, label: '紅包總覽' },
  { id: 'records' as const, label: '記錄列表' },
  { id: 'bulk' as const, label: '批量登記' },
  { id: 'add' as const, label: '新增記錄' },
] as const;

export function formatAmount(amount: number, currency: string = 'TWD'): string {
  const currencySymbol = currency === 'TWD' ? 'NT$' : currency === 'USD' ? '$' : currency;
  return `${currencySymbol} ${amount.toLocaleString()}`;
}

export function formatGiftType(type: GiftType): string {
  switch (type) {
    case 'cash': return '現金';
    case 'gift': return '禮品';
    case 'both': return '現金+禮品';
    default: return type;
  }
}
